<template>
    <v-responsive fluid v-resize="resize">
        <v-card min-width="375" rounded="0">
            <v-card-title>
                <v-row align="start">
                    <v-col cols="12" :md="hasManagerPermission ? '6' : '12'">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar upfront"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="8"
                        :md="hasAdminPermission ? '6' : '6'"
                        v-if="hasManagerPermission"
                    >
                        <v-select
                            :items="comerciales"
                            v-model="selectedComercial"
                            item-text="nombreCompleto"
                            return-object
                            prepend-inner-icon="mdi-account"
                            :menu-props="{ maxHeight: '600' }"
                            label="Comercial"
                        >
                            <template #item="{ item }">
                                <v-row>
                                    <v-col
                                        :cols="
                                            $vuetify.breakpoint.smAndDown
                                                ? 10
                                                : 9
                                        "
                                    >
                                        {{ item.nombreCompleto }}
                                    </v-col>
                                    <v-col
                                        v-if="
                                            item.estado &&
                                            !$vuetify.breakpoint.smAndDown
                                        "
                                        cols="3"
                                    >
                                        <v-chip
                                            label
                                            :color="
                                                estadoComercial[item.estado]
                                            "
                                            medium
                                            class="
                                                d-flex
                                                justify-center
                                                overline
                                            "
                                        >
                                            {{ item.estado }}
                                        </v-chip>
                                    </v-col>
                                    <v-col
                                        v-if="
                                            item.estado &&
                                            $vuetify.breakpoint.smAndDown
                                        "
                                        cols="2"
                                    >
                                        <v-icon
                                            :color="
                                                estadoComercial[item.estado]
                                            "
                                            large
                                            class="
                                                d-flex
                                                justify-center
                                                overline
                                            "
                                        >
                                            mdi-circle
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-card-text class="pa-0">
                <v-data-table
                    :height="tableHeight"
                    :headers="headers"
                    :items="upfronts"
                    :loading="isLoadingUpfronts"
                    :page.sync="page"
                    :footer-props="footerProps"
                    :items-per-page="20"
                    :server-items-length="totalEntries"
                    :options.sync="options"
                    :search="search"
                    class="px-2"
                    hide-default-footer
                >
                    <template v-slot:footer="{ props }">
                        <v-data-footer
                            style="height: 60px; justify-content: flex-end"
                            :items-per-page-options="props.itemsPerPageOptions"
                            :options.sync="options"
                            :pagination.sync="props.pagination"
                            show-first-last-page
                        >
                        </v-data-footer>
                    </template>
                    <template
                        v-if="hasManagerPermission"
                        v-slot:item.upfront="{ item }"
                    >
                        {{ parseFloat(item.upfront).toLocaleString() }} €
                    </template>
                    <template
                        v-if="
                            selectedComercial &&
                            selectedComercial.currentReward.rewardType ==
                                'BOLSA_VARIABLE'
                        "
                        v-slot:item.upfront_comercial="{ item }"
                    >
                        {{
                            parseFloat(
                                item.upfront *
                                    ((hasManagerPermission
                                        ? selectedComercial.currentReward.amount
                                        : selectedComercial.currentReward
                                              .amount) *
                                        0.01)
                            ).toLocaleString()
                        }}
                        €
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <div id="control-height"></div>
    </v-responsive>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone } from '@/util/libUtil';

export default {
    name: 'TablaUpfront',
    data: () => ({
        options: {},
        footerProps: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [0],
        },
        tableHeight: 300,
        estadoComercial: {
            ALTA: 'success',
            BAJA: 'warning',
            INACTIVO: 'error',
            VACACIONES: 'blue',
        },
        search: null,
        headers: [
            {
                text: 'Nombre del servicio',
                align: 'start',
                value: 'name',
            },
            {
                text: 'Tipo',
                value: 'tipo',
                align: 'center',
            },
            // {
            //     text: 'Upfront comercial',
            //     value: 'currentReward',
            //     align: 'center',
            //     sortable: false,
            // },
        ],
        selectedComercial: null,
    }),
    methods: {
        resize() {
            this.tableHeight =
                document.getElementById('control-height').clientHeight -
                81 -
                40 -
                70 -
                32 -
                8 -
                16 -
                15;
        },
        updateTableHeader() {
            if (!this.selectedComercial) {
                return;
            } else {
                if (
                    this.selectedComercial.currentReward.rewardType ==
                    'BOLSA_VARIABLE'
                ) {
                    !this.headers.some(
                        ({ value }) => value == 'upfront_comercial'
                    ) &&
                        this.headers.push({
                            text: `Upfront comercial ${
                                this.hasManagerPermission
                                    ? parseFloat(
                                          this.selectedComercial.currentReward
                                              .amount
                                      ).toLocaleString() + '%'
                                    : ''
                            }`,
                            value: 'upfront_comercial',
                            align: 'center',
                        });

                    this.headers.find(
                        ({ value }) => value === 'upfront_comercial'
                    ).text = `Upfront comercial ${
                        this.hasManagerPermission
                            ? parseFloat(
                                  this.selectedComercial.currentReward.amount
                              ).toLocaleString() + '%'
                            : ''
                    }`;
                } else {
                    this.headers.some(
                        ({ value }) => value == 'upfront_comercial'
                    ) &&
                        this.headers.splice(
                            this.headers.findIndex(
                                ({ value }) => value == 'upfront_comercial'
                            ),
                            1
                        );
                }
            }

            clone(this.headers);
        },
        ...mapActions('teletrabajo', ['fetchComerciales']),
        ...mapActions('login', ['getUserDetails']),
        ...mapActions('areaPersonal/calculadora', ['fetchUpfronts']),
    },
    computed: {
        page: {
            get() {
                return this.$store.state.areaPersonal.calculadora.upfrontTable
                    .page;
            },
            set(val) {
                this.$store.commit(
                    'areaPersonal/calculadora/tableUpfrontPage',
                    val
                );
            },
        },
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        ...mapState('areaPersonal/calculadora', {
            upfronts: (state) => state.upfrontTable.upfronts,
            isLoadingUpfronts: (state) => state.isLoadingUpfronts,
            totalEntries: (state) => state.upfrontTable.totalEntries,
        }),
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasAdminPermission: 'hasAdminPermission',
        }),
    },
    created() {
        if (this.hasManagerPermission) {
            this.fetchComerciales();
            this.headers.splice(this.headers.length - 1, 1, {
                text: 'Upfront',
                value: 'upfront',
                align: 'center',
            });
        } else {
            this.getUserDetails().then(() => {
                this.selectedComercial = this.cuenta;
            });
        }
    },
    watch: {
        search() {
            let text = this.search;
            // Evitar sobre cargas a la API, solo hace la peticion cuando dejas de escribir
            setTimeout(() => {
                if (text == this.search) {
                    this.options.page = 1;
                    this.$store.dispatch(
                        'areaPersonal/calculadora/updateUpfrontTableParams',
                        {
                            search: this.search,
                        }
                    );
                    this.fetchUpfronts();
                }
            }, 300);
        },
        options: {
            immediate: false,
            handler() {
                let page = this.options.page;
                setTimeout(() => {
                    if (
                        this.options.page == page &&
                        !this.firstloaded &&
                        !this.isLoadingUpfronts
                    ) {
                        this.$store.dispatch(
                            'areaPersonal/calculadora/updateUpfrontTableParams',
                            this.options
                        );
                        this.fetchUpfronts();
                    }
                }, 200);
            },
            // Permite que el handler se ejecute cuando cambie cualquiera de los campos de options
            deep: true,
        },
        tableHeight() {
            this.footerProps.itemsPerPageOptions[0] = Math.floor(
                this.tableHeight / 48 - 1
            );
            this.options.itemsPerPage = this.footerProps.itemsPerPageOptions[0];
            this.firstloaded = false;
        },
        totalEntries() {
            if (this.totalEntries <= this.footerProps.itemsPerPageOptions[0]) {
                //  this.options.page = 1
            }
        },
        selectedComercial() {
            this.updateTableHeader();
        },
        comerciales() {
            if (this.selectedComercial) {
                this.comerciales.some(
                    (comercial) =>
                        comercial.id == this.selectedComercial.id &&
                        (this.selectedComercial = comercial)
                );

                this.updateTableHeader();
            }
        },
    },
};
</script>